import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import {submitRole, updateRole} from "../../../services/user/role";

export function RoleForm({role, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [title, setTitle] = useState("")
  const [status, setStatus] = useState(false)

  useEffect(() => {
    setId((role && role.id) || null);
    setTitle((role && role.title) || "");
    setStatus(role && role.status && role.status === 'enable' ? true : false);
  }, [role]);

  const save = async () => {
    const data = {id, title, status: status ? 'enable' : 'disable'};
    let result;

    if (!id) {
      result = await submitRole(data);
    } else {
      result = await updateRole(data);
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody>
          <div className="mb-4">
            <Input variant="standard"
                   value={title}
                   label={Dict('title')}
                   placeholder={Dict('title')}
                   onChange={(e) => {
                     setTitle(e.target.value)
                   }}
            />
          </div>
          <div className="mb-4">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={status}
              onChange={(e) => {
                setStatus(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}